import axios from 'axios';

// Radio Recording Server v2 API（RESTful）。
// 開發與正式環境預設都打正式 API；若要覆寫請設定 VITE_API_BASE_URL。
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://api.record.nogi46.me/api/v2';

const instance = axios.create({
  baseURL: API_BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('oidc_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export { API_BASE_URL };
export default instance;
